import React, { useRef } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import AutoComplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';

function ThirdPartyLogisticsASNForm(props) {

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
          props.getAcumaticaTransferOrder();
        };
    };

     return(
        <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} display = "flex" flexDirection = "column">
            <Stack direction = "row" alignItems = {"center"}>
                <FormControl sx = {{ width: '15%', mr: '0.6%' }}>
                    <AutoComplete
                        value = {props.warehouse_options.find(option => option.value === props.warehouse) || null}
                        onChange = {(event, newValue) => {
                            props.setWarehouse(newValue ? newValue.value : null);
                        }}
                        id = "warehouse"
                        options = {props.warehouse_options}
                        getOptionLabel = {(option) => {
                            return `${option.name}`;
                        }}
                        renderOption = {(props, option) => {
                            return (
                                <li {...props}>
                                    {`${option.name}`}
                                </li>
                            );
                        }}
                        renderInput = {(params) => (
                            <TextField {...params} label = "Warehouse *" />
                        )}
                        required
                    />
                </FormControl> 
                { props.warehouse ?
                    <TextField 
                        name = 'orderNbr'
                        label = 'Transfer Order Number'
                        onChange = {(e) => props.setOrderNbr(e.target.value)}
                        value = {props.orderNbr}
                        sx = {{width: '20%', mr: '0.6%'}}
                        inputProps = {{ maxLength: 7 }}
                        onKeyDown = {handleKeyDown}
                        required
                    />
                : null }
              
                { props.orderNbr ? 
                    <Button 
                        sx = {{ml: '10px'}} 
                        onClick = {props.getAcumaticaTransferOrder}
                        disabled = {props.isLoading} 
                    >
                        Get Transfer Order
                    </Button> 
                : null }
            </Stack>
      </Box>
    );
  };

export default ThirdPartyLogisticsASNForm;